import '@mrhenry/wp--bugsnag-config';

import './modules/mr-blocked-content';
import './modules/mr-video';

import { MrInputSink, MrMenu } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-input-sink', MrInputSink );
customElements.define( 'mr-menu', MrMenu );
